import { Link } from "react-router-dom";
import { getMostViewedArticles } from "@/mocks/articles";

export default function TrendingSection() {
  const trending = getMostViewedArticles(5);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="lg:w-[40%]">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20scene%20of%20a%20journalist%20investigating%20behind%20a%20red%20velvet%20curtain%2C%20mysterious%20atmosphere%2C%20warm%20golden%20backlight%2C%20cinematic%20composition%2C%20clean%20neutral%20background%2C%20editorial%20photography%20style%2C%20rich%20burgundy%20and%20cream%20tones&width=800&height=600&seq=trending-feature-img&orientation=landscape"
                alt="每日黑料主编深度报道"
                title="每日黑料 - 主编深度"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:w-[60%] flex flex-col justify-center">
            <span className="text-xs text-foreground-500 font-medium tracking-wider uppercase mb-3">
              （每日黑料 · 主编深度）
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight mb-4">
              黑料每日爆料
              <span className="text-foreground-400 font-normal"> · 不看后悔</span>
            </h2>
            <blockquote className="text-base text-foreground-600 leading-relaxed mb-6 border-l-3 border-primary-400 pl-5 italic">
              "每日黑料吃瓜网最新地址，网红塌房现场直击第一线。我们不生产瓜，我们只是黑料的搬运工。每一篇爆料都经过团队多方核实，确保内容的真实性和时效性。"
            </blockquote>
            <p className="text-sm font-heading font-bold text-foreground-800">
              —— 每日黑料编辑部
            </p>

            <div className="flex items-center gap-2 mt-8">
              <Link
                to="/category/chigua-baoliao"
                className="px-5 py-2.5 bg-foreground-900 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                浏览全部爆料
              </Link>
              <Link
                to="/category/meiri-dasai"
                className="px-5 py-2.5 border border-foreground-300 text-foreground-700 text-sm font-medium rounded-full hover:border-primary-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                每日黑料大赛入口
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3">
          {trending.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="flex flex-col items-center text-center p-4 rounded-xl bg-background-50 hover:bg-background-200/70 transition-colors cursor-pointer group border border-background-200/70"
            >
              <span className="text-2xl font-heading font-black text-primary-300 group-hover:text-primary-500 transition-colors mb-2">
                {String(index + 1).padStart(2, "0")}
              </span>
              <p className="text-sm text-foreground-700 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                {article.title}
              </p>
              <span className="text-xs text-foreground-500 mt-2 whitespace-nowrap">
                {article.viewCount >= 10000 ? `${(article.viewCount / 10000).toFixed(1)}万阅读` : `${article.viewCount}阅读`}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}